import { Routes, Route } from 'react-router-dom'
import Layout from '@components/Layout/Layout'
import Home from '@pages/Home/Home'
import About from '@pages/About/About'
import Solutions from '@pages/Solutions/Solutions'
import Apps from '@pages/Apps/Apps'
import Contact from '@pages/Contact/Contact'
import NotFound from '@pages/NotFound/NotFound'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="sobre" element={<About />} />
        <Route path="solucoes" element={<Solutions />} />
        <Route path="apps" element={<Apps />} />
        <Route path="contato" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
